import React from 'react'

import {VideoHero as VideoHeroSection} from '@/sections/video-hero'

import type {VideoHeroFragment} from '@/graphql-types'

interface Props {
    slice: VideoHeroFragment
}

export const VideoHero = React.forwardRef<HTMLDivElement, Props>(
    ({slice: {primary: content}}: Props, ref) => (
        <VideoHeroSection
            title={content.title}
            body={content.lead_text.richText}
            ctaText={content.cta_text}
            ctaLink={content.cta_link}
            videoWebM={content.video_webm}
            videoMP4={content.video_mp4}
            videoPosterImage={content.video_poster_image}
            submitText={content.signup_label}
            ref={ref}
        />
    ),
)
